import { useCallback } from "react";
import { useContent } from "../../../../contexts/contentContext/contentContext";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import {
  selectAddonData,
  selectAddonQuantity,
  selectIsFetchingAddonData,
} from "../store/purchasesSelectors";
import type { PackageTypeRouteT } from "../models/models";
import { useParams } from "react-router-dom";
import { fetchAddonData } from "../store/purchasesThunks";
import { setAddonQuantity } from "../store/purchasesSlice";
import { useUser } from "../../../../contexts/userContext/userContext";

const useAddon = () => {
  const { packageType } = useParams<{
    packageType: PackageTypeRouteT;
  }>();
  const dispatch = useAppDispatch();
  const { getLanguage } = useContent();
  const addonData = useAppSelector(selectAddonData);
  const addonQuantity = useAppSelector(selectAddonQuantity) || 0;
  const { getUserData } = useUser();

  const fetchAddon = useCallback(async () => {
    dispatch(
      fetchAddonData({
        addonName: packageType!,
        culture: getLanguage(),
      })
    );
  }, [packageType, getLanguage()]);

  const updateAddonQuantity = useCallback((quantity: number) => {
    dispatch(setAddonQuantity(quantity));
  }, []);

  const existingAddonQuantity = (() => {
    let quantity = 0;
    switch (packageType!) {
      case "sub-users":
        quantity = getUserData()?.UserTotalSubUsersLicenses;
        break;
      case "extra-storage":
        quantity = getUserData()?.NumOfExtraStorage;
        break;
    }
    return quantity;
  })();

  const isFetchingAddonData = useAppSelector(selectIsFetchingAddonData);

  return {
    fetchAddonData: fetchAddon,
    addonData,
    isFetchingAddonData,
    addonQuantity,
    setAddonQuantity: updateAddonQuantity,
    existingAddonQuantity,
  };
};

export default useAddon;
